import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const withAuthProtection = (Component) => {
    const ProtectedComponent = (props) => {
        const user = useSelector((state) => state.auth.user);
        if (!user) {
            return <Navigate to="/login" />;
        }
        return <Component {...props} />;
    };
    return ProtectedComponent;
};

export default withAuthProtection;